var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 -6.10352e-05C4.48012 -6.10352e-05 0.00012207 4.47994 0.00012207 9.99994C0.00012207 15.5199 4.48012 19.9999 10.0001 19.9999C15.5201 19.9999 20.0001 15.5199 20.0001 9.99994C20.0001 4.47994 15.5201 -6.10352e-05 10.0001 -6.10352e-05ZM11.0001 16.9999H9.00012V14.9999H11.0001V16.9999ZM13.0701 9.24994L12.1701 10.1699C11.4501 10.8999 11.0001 11.4999 11.0001 12.9999H9.00012V12.4999C9.00012 11.3999 9.45012 10.3999 10.1701 9.66994L11.4101 8.40994C11.7801 8.04994 12.0001 7.54994 12.0001 6.99994C12.0001 5.89994 11.1001 4.99994 10.0001 4.99994C8.90012 4.99994 8.00012 5.89994 8.00012 6.99994H6.00012C6.00012 4.78994 7.79012 2.99994 10.0001 2.99994C12.2101 2.99994 14.0001 4.78994 14.0001 6.99994C14.0001 7.87994 13.6401 8.67994 13.0701 9.24994Z",
    fill: "#2B59A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.ca727fd1.svg";
export { ForwardRef as ReactComponent };